import { faCog } from '@fortawesome/free-solid-svg-icons';
import { GIButton } from 'app-components';
import AccordionPanel from '@components/common/app-components/AccordionPanel';
import React, { useCallback, useContext } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { ConditionalRendering } from '@components/common/conditional-rendering';
import { ENROLLMENT_STATUSES } from '@constants/individualPortal/dashboard/dashboardModelTypes';
import { IEnrollment } from '../common/types';
import { EnrollmentContext } from '../context/MemberMyEnrollmentProvider';
import useEnrollmentModal from '../hooks/useEnrollmentModal';

const StyledActionsContainer = styled.div`
    .header-container {
        justify-content: end;
        border-radius: 0;
        svg {
            width: 1.7rem;
        }
        a {
            display: flex;
        }

        .header {
            padding: 2px 0 0 3px;
            width: fit-content;
        }
    }
    .content {
        border: none;
        padding: 10px !important;
    }
    > div {
        border: 0;
    }
`;

const StyledLink = styled.a`
    color: ${({ theme }) => theme.primaryMain} !important;
    display: flex;
    align-items: center;
    font-weight: 600;
`;

const StyledAccordionContent = styled.div`
    display: flex;
    justify-content: center;
    gap: 0.5rem;
`;

interface IPremiumHistoryActionsProps {
    enrollment: IEnrollment;
}

const PremiumHistoryActions: React.FC<IPremiumHistoryActionsProps> = ({ enrollment }) => {
    const intl = useIntl();
    const { setIsEdit, setViewAddOrChangeTxn } = useContext(EnrollmentContext);

    const onChangePremiumHistory = () => {
        setIsEdit(true);
    };

    const { handlePremiumHistory, premiumHistory } = useEnrollmentModal();

    const handlCancelPremiumHistoryClick = useCallback(() => {
        handlePremiumHistory(enrollment, premiumHistory);
    }, [enrollment, premiumHistory]);

    const handleAddPremiumHistoryClick = useCallback(() => {
        setIsEdit(false);
        setViewAddOrChangeTxn(true);
    }, []);

    return (
        <StyledActionsContainer className="history-actions" data-testid={'premium-history-actions'}>
            <AccordionPanel
                id={'additionnalInfo'}
                ariaControlsId='premiumHistoryPanel'
                header={<StyledLink> {intl.formatMessage({ id: 'common.actions' })}</StyledLink>}
                isLeftToggle={true}
                expandedIcon={faCog}
                collapsedIcon={faCog}
                isHeaderClickable={true}
            >
                <StyledAccordionContent>
                    <ConditionalRendering isTrue={enrollment.enrollmentStatus !== ENROLLMENT_STATUSES.CANCEL}>
                        <GIButton
                            id="premiumhistoryCancel"
                            onClickHandler={handlCancelPremiumHistoryClick}
                            variant="secondary"
                            label={intl.formatMessage({
                                id: 'member.enrollment_list.premiumhistory.cancel',
                            })}
                        ></GIButton>
                    </ConditionalRendering>

                    <ConditionalRendering isTrue={enrollment.enrollmentStatus === ENROLLMENT_STATUSES.CANCEL}>
                        <GIButton
                            id="premiumhistoryAdd"
                            onClickHandler={handleAddPremiumHistoryClick}
                            variant="secondary"
                            label={intl.formatMessage({ id: 'member.enrollment_list.premiumhistory.add' })}
                        ></GIButton>
                    </ConditionalRendering>

                    <GIButton
                        id="premiumhistoryChange"
                        onClickHandler={onChangePremiumHistory}
                        variant="secondary"
                        label={intl.formatMessage({ id: 'member.enrollment_list.premiumhistory.change' })}
                    ></GIButton>
                </StyledAccordionContent>
            </AccordionPanel>
        </StyledActionsContainer>
    );
};

export default PremiumHistoryActions;
